export default __webpack_public_path__ + "static/media/nexus_maly.9446844a.png";